import { c as _c } from "react/compiler-runtime";
import { Carousel, CarouselSlide } from "@mantine/carousel";
import { Avatar, Badge, Rating } from "@mantine/core";
import { alldayjs } from "@/lib/dayjs";
import PureHtml from "../custom/PureHtml";
export default function ReviewsSlider(t0) {
  const $ = _c(19);
  const {
    areviews,
    reviews
  } = t0;
  const t1 = areviews?.heading || "Our Reviews";
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="text-xl lg:text-2xl">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = areviews?.subtext;
  let t4;
  if ($[2] !== t3) {
    t4 = <PureHtml html={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "aria-label": "Previous"
    };
    t6 = {
      "aria-label": "Next"
    };
    t7 = {
      base: "100%",
      sm: "70%",
      md: "33.333%"
    };
    t8 = {
      loop: true,
      align: "start",
      slidesToScroll: 2
    };
    t9 = {
      display: "flex",
      flexDirection: "column-reverse"
    };
    t10 = {
      position: "relative",
      width: "100px",
      marginLeft: "auto"
    };
    $[4] = t10;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t10 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      root: t9,
      controls: t10,
      control: {
        pointerEvents: "all",
        background: "white",
        color: "black",
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        "&[dataInactive]": {
          opacity: 0,
          cursor: "default"
        }
      }
    };
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== reviews) {
    t12 = reviews?.length > 0 && reviews.map(_temp);
    $[11] = reviews;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t12) {
    t13 = <div className="flex"><div className="w-full"><Carousel withIndicators={false} slideGap="md" previousControlProps={t5} nextControlProps={t6} slideSize={t7} emblaOptions={t8} styles={t11}>{t12}</Carousel></div></div>;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13 || $[16] !== t2 || $[17] !== t4) {
    t14 = <section className="review-slider py-2 lg:py-3"><div className="max-w-7xl mx-auto px-2">{t2}{t4}{t13}</div></section>;
    $[15] = t13;
    $[16] = t2;
    $[17] = t4;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  return t14;
}
function _temp(hrev, idx) {
  const name = hrev?.first_name + " " + hrev?.last_name;
  return <CarouselSlide key={idx} my="xs"><div className="bg-white p-2 shadow rounded h-full"><Rating value={5} size="sm" readOnly={true} my="md" /><div className="font-heading text-base lg:text-xl">{hrev?.review_title}</div><PureHtml html={hrev?.review_text} /><div className="flex gap-1 items-center"><Avatar size={50} key={name} name={name} color="initials" /><div className="capitalize line-clamp-1">{name}</div><div className="text-xs opacity-70">{alldayjs(hrev?.created_at).fromNow(true)} ago</div><Badge color="lime" c="white" autoContrast={true} fw={400}>Verified</Badge></div></div></CarouselSlide>;
}